import { Copy, Landmark } from "lucide-react";
import { toast } from "@/components/ui/sonner";

export default function BankAccounts({ contas }) {
  if (!contas || contas.length === 0) return null;

  const copy = async (texto, label) => {
    try {
      await navigator.clipboard.writeText(texto);
      toast.success(`${label} copiado!`);
    } catch (e) {
      toast.error("Não foi possível copiar.");
    }
  };

  const copyAll = (c) => {
    const t = [`Banco: ${c.banco}`, `Agência: ${c.agencia}`, `Conta ${c.tipo || "Corrente"}: ${c.conta}`, c.titular && `Titular: ${c.titular}`, c.documento && `CPF/CNPJ: ${c.documento}`].filter(Boolean).join("\n");
    copy(t, "Dados bancários");
  };

  return (
    <div data-testid="bank-accounts" className="bg-emerald-50/70 border border-emerald-100 rounded-2xl p-4 sm:p-5">
      <p className="text-base font-semibold text-slate-700 mb-1 inline-flex items-center gap-2"><Landmark className="w-4 h-4 text-emerald-700" /> Ou transfira para uma conta</p>
      <p className="text-sm text-slate-500 mb-3">Toque em um dado para copiar.</p>
      <div className="space-y-3">
        {contas.map((c, i) => (
          <div key={i} data-testid={`bank-account-public-${i}`} className="bg-white rounded-xl border border-emerald-100 p-3.5">
            <div className="flex items-center justify-between gap-2 mb-2">
              <p className="font-heading font-bold text-slate-900">{c.banco}</p>
              <button type="button" data-testid={`bank-copy-all-${i}`} onClick={() => copyAll(c)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold transition-colors">
                <Copy className="w-3.5 h-3.5" /> Copiar tudo
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Item label="Agência" value={c.agencia} onCopy={() => copy(c.agencia, "Agência")} testid={`bank-copy-agencia-${i}`} />
              <Item label={`Conta ${c.tipo || "Corrente"}`} value={c.conta} onCopy={() => copy(c.conta, "Conta")} testid={`bank-copy-conta-${i}`} />
              {c.titular && <Item label="Titular" value={c.titular} onCopy={() => copy(c.titular, "Titular")} testid={`bank-copy-titular-${i}`} wide />}
              {c.documento && <Item label="CPF/CNPJ" value={c.documento} onCopy={() => copy(c.documento, "CPF/CNPJ")} testid={`bank-copy-documento-${i}`} wide />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Item({ label, value, onCopy, testid, wide }) {
  return (
    <button type="button" data-testid={testid} onClick={onCopy} className={`text-left rounded-lg bg-slate-50 hover:bg-emerald-50 border border-slate-100 px-3 py-2 transition-colors ${wide ? "col-span-2" : ""}`}>
      <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{label}</p>
      <p className="font-code text-base font-bold text-slate-800 break-all flex items-center justify-between gap-2">{value} <Copy className="w-3.5 h-3.5 text-slate-400 shrink-0" /></p>
    </button>
  );
}
